`!has('dom-pointer-events')`;
import 'pepjs';

`!has('dom-intersection-observer')`;
import 'intersection-observer';

`!has('dom-webanimation')`;
import 'web-animations-js/web-animations-next-lite.min';
